import { Link } from "react-router-dom";
import { mangaList } from "@/mocks/manga";
import { SectionTitle } from "./SectionTitle";

export default function NewReleases() {
  const items = mangaList.slice(0, 8);

  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionTitle
          eyebrow="DAILY UPDATE"
          title="最新上架 · 每日更新"
          desc="番木瓜漫画最新上架内容每日更新，新作上线第一时间送达。"
          to="/serial"
          linkText="查看更多新作"
        />

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4">
          {items.map((m, i) => (
            <Link
              key={m.id}
              to={`/article/${m.id}`}
              className="group relative overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition hover:-translate-y-1 hover:shadow-soft"
            >
              <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
                <img
                  src={m.cover}
                  alt={`${m.title} 最新上架`}
                  className="h-full w-full object-cover object-top transition duration-300 group-hover:scale-105"
                />
                {i < 3 && (
                  <span className="absolute left-2.5 top-2.5 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-bold text-background-50">
                    <i className="ri-flashlight-fill mr-1 text-[10px]"></i>
                    今日上新
                  </span>
                )}
                <span className="absolute bottom-2.5 right-2.5 flex items-center gap-1 rounded-full bg-foreground-950/70 px-2 py-0.5 text-xs text-background-50 backdrop-blur">
                  <i className="ri-book-open-line text-[10px]"></i>
                  连载至 {m.chapters} 话
                </span>
              </div>
              <div className="p-3">
                <h3 className="truncate text-sm font-bold text-foreground-900">
                  {m.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500">{m.season}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}